import type { ListParams } from '../type';
import baseKey from './_baseKey';

const cleanierUsersDomainKey = (cleanierUsersSubDomains?: string[]) =>
  baseKey.domainKey('cleanierUsers', cleanierUsersSubDomains);

/**
 * 클리니어 유저 관련 쿼리키 제너레이터
 */
const cleanierUsersKey = {
  /**
   * @returns 클리니어 유저 도메인 기본 쿼리키 (getter)
   * @example ['cleanierUsers']
   */
  domain() {
    return cleanierUsersDomainKey();
  },
  /**
   * @param id 클리니어 유저 ID
   * @returns ID에 대하는 클리니어 유저 상세 데이터 요청 쿼리키
   * @example ['cleanierUsers', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(cleanierUsersDomainKey(), 'detail'), id];
  },
  /**
   * @param listParams 고객사 ID 포함한 리스트 파라미터
   * @returns 페이지네이션 방식 지점 리스트 데이터 요청 쿼리키
   * @example ['venue', 'list', 'scroll', {...listParams}]
   */
  listByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(cleanierUsersDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
};

export default Object.freeze(cleanierUsersKey);
